import { createTypes, createAction } from 'lib/action'

// *load ข้อมูลต้นแหล่ง
const SOURCE_QUALITY_EVALUATION_LOCATION = createTypes(
  'sourceQualityEvaluationLoadLocation',
  'load'
)

// *laod ข้อมูลวัตถุดิบ
const SOURCE_QUALITY_EVALUATION_RAW_MATERIAL = createTypes(
  'sourceQualityEvaluationLoadRawMaterial',
  'load'
)

// *laod ข้อมูลวัตถุดิบสำหรับหน้า create
const SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE = createTypes(
  'sourceQualityEvaluationLoadRawMaterialForCreate',
  'load'
)

// *load ข้อมูล form ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_REQUEST_FORM = createTypes(
  'sourceQualityEvaluationLoadRequestForm',
  'load'
)

// *load table log ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_TABLE_LOG = createTypes(
  'sourceQualityEvaluationLoadTableLog',
  'load'
)

// *load detail ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_DETAIL = createTypes(
  'sourceQualityEvaluationLoadDetail',
  'load'
)

// *create form ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_CREATE = createTypes(
  'sourceQualityEvaluationCreateForm',
  'create'
)

// *ลบ form ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_DELETE = createTypes(
  'sourceQualityEvaluationDeleteForm',
  'delete'
)

// *calculate form ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_CALCULATE = createTypes(
  'sourceQualityEvaluationCalculateForm',
  'load'
)

// *export 1 form ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_EXPORT_ONE_FORM = createTypes(
  'sourceQualityEvaluationExportOneForm',
  'export'
)

// *export หลาย form ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM = createTypes(
  'sourceQualityEvaluationExportMultipleForm',
  'export'
)

// *load ข้อมูลศูนย์ทดสอบ
const SOURCE_QUALITY_EVALUATION_TEST_CENTER = createTypes(
  'sourceQualityEvaluationLoadTestCenter',
  'load'
)

// *edit form ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_EDIT = createTypes(
  'sourceQualityEvaluationEditForm',
  'update'
)

// *export excel
const SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL = createTypes(
  'sourceQualityEvaluationExportExcel',
  'export'
)

// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load ข้อมูลต้นแหล่ง
const sourceQualityEvaluationLoadLocation = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_LOCATION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_LOCATION.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_LOCATION.FAITLURE),
}

// *load ข้อมูลวัตถุดิบ
const sourceQualityEvaluationLoadRawMaterial = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_RAW_MATERIAL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_RAW_MATERIAL.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_RAW_MATERIAL.FAITLURE),
}

// *load ข้อมูลวัตถุดิบสำหรับหน้า create
const sourceQualityEvaluationLoadRawMaterialForCreate = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE.FAITLURE),
}

// *load table log ประเมินคุณภาพ
const sourceQualityEvaluationLoadTableLog = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_TABLE_LOG.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_TABLE_LOG.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_TABLE_LOG.FAITLURE),
}

// *load ข้อมูล form ประเมินคุณภาพ
const sourceQualityEvaluationLoadRequestForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_REQUEST_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_REQUEST_FORM.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_REQUEST_FORM.FAITLURE),
}

// *load detail ประเมินคุณภาพ
const sourceQualityEvaluationLoadDetail = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_DETAIL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_DETAIL.FAITLURE),
}

// *create form ประเมินคุณภาพ
const sourceQualityEvaluationCreateForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_CREATE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_CREATE.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_CREATE.FAITLURE),
}

// *ลบ form ประเมินคุณภาพ
const sourceQualityEvaluationDeleteForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_DELETE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_DELETE.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_DELETE.FAITLURE),
}

// *calculate form ประเมินคุณภาพ
const sourceQualityEvaluationCalculateForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_CALCULATE.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_CALCULATE.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_CALCULATE.FAITLURE),
}

// *export 1 form ประเมินคุณภาพ
const sourceQualityEvaluationExportOneForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_ONE_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_ONE_FORM.SUCCESS, { lists }),
  failure: () =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_ONE_FORM.FAITLURE),
}

// *export หลาย form ประเมินคุณภาพ
const sourceQualityEvaluationExportMultipleForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM.FAITLURE),
}

// *load ข้อมูล test center
const sourceQualityEvaluationLoadTestCenter = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_TEST_CENTER.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_TEST_CENTER.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_TEST_CENTER.FAITLURE),
}

// *load table log ประเมินคุณภาพ
const sourceQualityEvaluationExportExcel = {
  request: (data) =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL.FAITLURE),
}
// *edit form ประเมินคุณภาพ
const sourceQualityEvaluationEditForm = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_EDIT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_EDIT.SUCCESS, { lists }),
  failure: () => createAction(SOURCE_QUALITY_EVALUATION_EDIT.FAITLURE),
};

export {
  SOURCE_QUALITY_EVALUATION_LOCATION,
  sourceQualityEvaluationLoadLocation,
  SOURCE_QUALITY_EVALUATION_RAW_MATERIAL,
  sourceQualityEvaluationLoadRawMaterial,
  SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE,
  sourceQualityEvaluationLoadRawMaterialForCreate,
  SOURCE_QUALITY_EVALUATION_TABLE_LOG,
  sourceQualityEvaluationLoadTableLog,
  SOURCE_QUALITY_EVALUATION_REQUEST_FORM,
  sourceQualityEvaluationLoadRequestForm,
  SOURCE_QUALITY_EVALUATION_DETAIL,
  sourceQualityEvaluationLoadDetail,
  SOURCE_QUALITY_EVALUATION_CREATE,
  sourceQualityEvaluationCreateForm,
  SOURCE_QUALITY_EVALUATION_DELETE,
  sourceQualityEvaluationDeleteForm,
  SOURCE_QUALITY_EVALUATION_CALCULATE,
  sourceQualityEvaluationCalculateForm,
  SOURCE_QUALITY_EVALUATION_EXPORT_ONE_FORM,
  sourceQualityEvaluationExportOneForm,
  SOURCE_QUALITY_EVALUATION_EXPORT_MULTIPLE_FORM,
  sourceQualityEvaluationExportMultipleForm,
  SOURCE_QUALITY_EVALUATION_TEST_CENTER,
  sourceQualityEvaluationLoadTestCenter,
  SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL,
  sourceQualityEvaluationExportExcel,
  SOURCE_QUALITY_EVALUATION_EDIT,
  sourceQualityEvaluationEditForm,
  REMOVE_LISTS,
  removeLists,
}
